const modalReason = {
  actionCancel: 'Cancelar',
  adminLocked: 'Administrador bloqueado',
  constractTerminated: 'Contrato rescindido',
  temporarySuspended: 'Temporário suspenso',
  textAreaPlaceholder: 'Inserir o motivo',
};

export default modalReason;
